import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { TenantProvider } from './contexts/TenantContext.jsx'
import { getCurrentTenant } from './config/servers.js'
import './index.css'

// Apply per-tenant browser-tab branding (title + favicon) before first paint.
// The same build serves every tenant, so index.html ships only neutral
// defaults — the real title/favicon come from the resolved tenant's config.
const tenant = getCurrentTenant()
if (tenant?.branding) {
  const { tabTitle, brandName, favicon } = tenant.branding
  document.title = tabTitle ?? brandName ?? document.title
  if (favicon) {
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = favicon
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <TenantProvider>
      <App />
    </TenantProvider>
  </React.StrictMode>,
)
